<app-auth-form
  [isRegister]="isRegister"
  [errorMessage]="errorMessage"
  [loading]="isLoading"
  (formSubmit)="onLogin($event)"
  (cancelMFA)="cancelMFA()"
></app-auth-form>
